<template>
	<div class="header special-font">
    <span>{{transify.BUY_TITLE}}
      <a class="rule" @click="showRule"></a>
      <a class="history" @click="showHistory"></a>
    </span>
		<div class="userinfo">
			<span class="gems">{{gems}}</span>
			<span class="uid">ID:{{uid}}</span>	
		</div>
	</div>
</template>
<script>
export default{
	name: "Header",
	data(){
		return{}
	},
	methods: {
		goBack(){
			this.$router.go(-1)
		},
		showRule(){
			this.$emit("showRule");
		},
		showHistory(){
			this.$emit("showHistory");
		}
	},
	computed:{
		gems: {
			get(){
				return this.$bus.player.gems
			},
			set(val){
				this.$bus.player.gems = val
			}
		},
		uid(){
			return this.$bus.player.uid
		},
		transify(){
			return this.$bus.transify
		}
	}
}
</script>
<style lang="scss" scoped>
  .header {
    text-align: center;
    background-size: 100% 100%;
    z-index: 1;
    position: relative;
    @include res-size($height: 100px);
    @include res-size(
      $height: 100px,
      $font-size: 48px
    );
    
    .rule,
    .history {
      position: absolute;
    }

    >span {
      position: relative;
      display: inline-block;
      color: #fff;
      @include res-size(
        $height: 90px,
        $line-height: 92px,
        $margin-top: 3px,
        $margin-left: -140px
      )
      &::before{
        content: '';
        position: absolute;
        @include res-size(
          // $min-width:552px
        )
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-position: left center;
        z-index: -1;
      }
    }

    .rule,
    .history {
      @include res-size(
        $width: 45px,
        $height: 45px,
        $top: 20px) background-size: 100% 100%;
    }

    .rule {
      @include res-size($right: -70px)
    }

    .history {
      @include res-size($right: -125px)
    }

    .userinfo {
      @include res-size(
        $height: 55px,
        $top: 20px,
        $right: 130px
      );
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      position: absolute;
      top: 0;
      line-height: 1;

      .gems {
        position: relative;
        display: inline-block;
        color: #fff;
        @include res-size($font-size: 36px);
        @include bgc;
        font-family: 'Bebas Neue Number';
        &::before {
          top: 50%;
          @include res-size(
            $width: 30px,
            $height: 26px,
            $left: -35px,
            $margin-top: -13px
          )
          position: absolute;
          display: inline-block;
          content: '';
          background-size: cover;
        }
      }

      .uid {
        @include res-size($font-size: 20px);
        color: #d4a84a;
        font-family: $base-font-family;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/header/index.vue